import React, {
  useState, useEffect, useContext,
  useMemo,
  createRef,
} from 'react';
// import { useFetchye } from 'fetchye';
import uuid from 'react-uuid';
import {
  ButtonPrimary,
  ButtonSecondary,
  DataTableV2,
  DataTableHeadV2,
  DataTableBodyV2,
  DataTableRowV2,
  DataTableHeadCellV2,
  DataTableCellV2,
  Select,
  SelectOption,
  IconTrash,
  IconShow,
  Heading,
  ProgressCircle,
} from '@americanexpress/dls-react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import {
  parseHtml, getUniqueFileId,
  base64ToBlobConversion, getMIMEType, encryptPayload,
} from '../../utils/util';
import { fetchS3Data } from '../../utils/utilService';
import { ChildContext } from '../context';

const getVal = require('lodash/get');

/**
 * returns DLS input component
 * @param {*} props
 */
/* eslint complexity: ["error", 51] -- need to increase complexity */
const PayloadFileAttachmentV2 = ({
  cssProperties,
  fieldValidation,
  fieldLabel,
  filesToAttach,
  fieldId,
  setFilesToAttach,
  entityToEdit,
  s3FileInfo,
  setS3FileInfo,
  filledFormData,
  isS3Upload = false,
  idGenField,
  formPageType,
  allS3FileIds,
  setAllS3FileIds,
  disabledButtons,
  setDisabledButtons,
  documents,
  buttonsToDisable = [],
  tableDynamicProperties = null,
  selectFileTypeProps = null,
  journeyId,
  comments,
}) => {
  const contextVal = useContext(ChildContext);
  const memberApiUrls = useSelector((state) => state.getIn(['config', 'memberApiUrls']));
  const [fileData, setFileData] = useState(null);
  const [uploadResponse, setUploadResponse] = useState([]);
  const [formatValid, setIsFormatValid] = useState(true);
  const [validationMsg, setValidationMsg] = useState({});
  const inputDls = cssProperties.inputStyle ? cssProperties.inputStyle : 'col-md-5 col-md-offset-1 margin-1-t margin-2-b';
  const uploadButtonDls = cssProperties.uploadButtonStyle ? cssProperties.uploadButtonStyle : 'col-md-3 col-md-offset-1 margin-1-t';
  const tableDls = cssProperties.tableStyle ? cssProperties.tableStyle : 'col-md-11 container margin-3-t';
  const errorBlockCss = cssProperties.errorBlockCss ? cssProperties.errorBlockCss : 'col-md-10 col-md-offset-1';
  const errorCss = cssProperties.errorBlockCss ? cssProperties.errorBlockCss : 'text-align-center dls-red';
  const [formatErrorMsg, setFormatErrorMsg] = useState({ message: fieldValidation && fieldValidation.formatErrorMsg ? fieldValidation.formatErrorMsg : 'Invalid file format!', doc_id: '' });
  const fileSizeLimit = fieldValidation && fieldValidation.fileSizeLimit >= 0
    ? fieldValidation.fileSizeLimit : 10;
  const totalFileSizeLimit = fieldValidation && fieldValidation.totalFileSizeLimit >= 0
    ? fieldValidation.totalFileSizeLimit : 30;
  const allowedNumberOfFiles = fieldValidation && fieldValidation.allowedNumberOfFiles
    ? fieldValidation.allowedNumberOfFiles : 5;
  const [totalFileSz, setTotalFileSz] = useState(0);
  const uploadButtonLabel = fieldLabel && fieldLabel.uploadButtonLabel ? fieldLabel.uploadButtonLabel : 'Upload';
  const removeDocButtonLabel = fieldLabel && fieldLabel.removeDocButtonLabel ? fieldLabel.removeDocButtonLabel : 'Remove';
  const tableDocNameHeader = fieldLabel && fieldLabel.tableDocNameHeader ? fieldLabel.tableDocNameHeader : 'Document Name';
  const tableDocNameDescription = fieldId && fieldId.tableDocNameDescription ? fieldLabel.tableDocNameDescription : 'Description';
  const tableDocStatusHeader = fieldLabel && fieldLabel.tableDocStatusHeader ? fieldLabel.tableDocStatusHeader : 'Description of status';
  const tableDocActions = fieldLabel && fieldLabel.tableDocActions ? fieldLabel.tableDocActions : 'Actions';
  const chooseFileButton = fieldLabel && fieldLabel.chooseFileButton ? fieldLabel.chooseFileButton : 'Choose file';
  const hideFileInput = fieldValidation && fieldValidation.hideFileInput
    ? fieldValidation.hideFileInput : false;
  const totalFileUploadText = fieldValidation && fieldValidation.totalFileUploadText
    ? fieldValidation.totalFileUploadText : 'Total files uploaded can be equal or less than';
  const fileSizeLimitError = fieldValidation && fieldValidation.fileSizeLimitError
    ? fieldValidation.fileSizeLimitError : 'File size can not exceed fileSizeLimit MB per file (totalFileSizeLimit MB in total)';
  const fileInputButton = document.querySelector(`#${fieldId}chooseFileButton`);
  const fileSizeError = fileSizeLimitError.replace('fileSizeLimit', fileSizeLimit).replace('totalFileSizeLimit', totalFileSizeLimit);
  const [isUploadInProgress, setIsUploadInProgress] = useState(false);
  const [selectedRow, setSelectedRow] = useState([]);
  const [uploadedFileType, setUploadedFileType] = useState('');
  const [selectFileTypeErrorMsg, setSelectFileTypeErrorMsg] = useState('');
  const [isView, setIsView] = useState({});
  const iformIntegrationUrls = useSelector((state) => state.getIn(['config', 'memberApiUrls']));

  const selectRefs = useMemo(() => {
    const refs = {};
    documents.every((row) => {
      row.documents.forEach((item) => {
        const key = item.document_id;
        refs[key] = createRef(null);
      });
      return true;
    });

    return refs;
  }, [documents]);

  const validationMessages = (type) => {
    switch (type) {
      case 'totalFileLength':
        if (fieldValidation && fieldValidation.numberOfFilesErrorMsg) {
          return fieldValidation.numberOfFilesErrorMsg;
        }
        return `${totalFileUploadText} ${allowedNumberOfFiles}.`;
      case 'fileSizeExceed':
        if (fieldValidation && fieldValidation.fileSizeLimitErrorMsg) {
          return fieldValidation.fileSizeLimitErrorMsg;
        }
        return `${fileSizeError}`;
      case 'totalFileSizeExceed':
        if (fieldValidation && fieldValidation.totalFileSizeExceedErrorMsg) {
          return fieldValidation.totalFileSizeExceedErrorMsg;
        }
        return `${fileSizeError}`;
      default:
        return null;
    }
  };

  const convertFileSizeToMB = (fileSizeBytes) => {
    let fileSizeMB = fileSizeBytes / 1e6;
    fileSizeMB = Math.trunc(fileSizeMB * 10000) / 10000;
    return fileSizeMB;
  };

  /**
           * handle input value
           * @param {*} event
           */
  const getRegexMap = () => {
    const rexMap = new Map();
    rexMap.set('pdf', /(\.pdf)$/i);
    rexMap.set('xlsx', /(\.xlsx)$/i);
    rexMap.set('png', /(\.png)$/i);
    rexMap.set('tif', /(\.tif)$/i);
    rexMap.set('jpg', /(\.jpg)$/i);
    rexMap.set('doc', /(\.doc)$/i);
    rexMap.set('ppt', /(\.ppt)$/i);
    rexMap.set('txt', /(\.txt)$/i);
    rexMap.set('xls', /(\.xls)$/i);
    rexMap.set('gif', /(\.gif)$/i);
    rexMap.set('xml', /(\.xml)$/i);
    rexMap.set('jpeg', /(\.jpeg)$/i);
    rexMap.set('docx', /(\.docx)$/i);
    rexMap.set('tiff', /(\.tiff)$/i);
    rexMap.set('bmp', /(\.bmp)$/i);
    rexMap.set('csv', /(\.csv)$/i);
    rexMap.set('msg', /(\.msg)$/i);
    rexMap.set('pptx', /(\.pptx)$/i);
    return rexMap;
  };

  const isFileValid = (fileName) => {
    const regexMap = getRegexMap();
    // console.log(regexMap);
    let validFile = false;
    if (fieldValidation && fieldValidation.allowedFormats) {
      fieldValidation.allowedFormats.forEach((format) => {
        const regex = regexMap.get(format);
        if (regex.exec(fileName)) {
          validFile = true;
        }
      });
    }
    return validFile;
  };

  /* eslint-disable max-len -- need */
  const validateFile = (data = null, rowId = null) => {
    if (data || (selectRefs[rowId] && selectRefs[rowId].current && selectRefs[rowId].current.files && selectRefs[rowId].current.files.length > 0)) {
      const file = data || selectRefs[rowId].current.files[0];
      setFileData('');
      const fileName = file.name;
      const fileSize = file.size;
      const calculatedFileSize = convertFileSizeToMB(totalFileSz) + convertFileSizeToMB(fileSize);

      if (fileInputButton) {
        fileInputButton.innerHTML = `${fileName}`;
      }

      if (!(uploadResponse.length >= allowedNumberOfFiles) || totalFileSizeLimit === 100) {
        // pass the file name through validation method
        if (fieldValidation && fieldValidation.allowedFormats && !isFileValid(fileName)) {
          setIsFormatValid(false);
          setFormatErrorMsg({ ...formatErrorMsg, doc_id: rowId });
          setValidationMsg({ ...validationMsg, message: validationMessages(''), doc_id: rowId });
          setFileData('');
        } else if (convertFileSizeToMB(fileSize) > fileSizeLimit) {
          setIsFormatValid(true);
          setValidationMsg({ ...validationMsg, message: validationMessages('fileSizeExceed'), doc_id: rowId });
        } else if (calculatedFileSize > totalFileSizeLimit) {
          if (fieldValidation && fieldValidation.totalFileSizeExceedErrorMsg) {
            setValidationMsg({ ...validationMsg, message: validationMessages('totalFileSizeExceed'), doc_id: rowId });
          } else {
            setValidationMsg({ ...validationMsg, message: validationMessages('fileSizeExceed'), doc_id: rowId });
          }
        } else {
          setFileData(file);
          setSelectedRow((prevState) => [...prevState, rowId]);
          setValidationMsg({ ...validationMsg, message: validationMessages(''), doc_id: rowId });
          setIsFormatValid(true);
        }
      } else {
        setValidationMsg({ ...validationMsg, message: validationMessages('totalFileLength'), doc_id: rowId });
      }
    } else {
      setIsFormatValid(true);
      setValidationMsg({});
    }
  };
  /* eslint-enable max-len -- need */
  const onFileChange = (event) => {
    const file = event.target.files[0];
    const rowId = event.target.id.split('$')[event.target.id.split('$').length - 1];
    validateFile(file, rowId);
  };

  const onFileUpload = async (rowId, documentTitle, other = false) => {
    const fileObj = {
      statusCode: 200,
      name: fileData.name,
      fileFrom: fieldId,
      type: fileData.type,
      size: fileData.size,
      fileSizeMb: convertFileSizeToMB(fileData.size),
      rowId: `${rowId}_${fileData.name}`,
      id: `${rowId}`,
      documentTitle,
      other,
    };
    if (selectFileTypeProps && !uploadedFileType) {
      setSelectFileTypeErrorMsg(selectFileTypeProps.noFileSelectedMsg);
      const fileTypeDropdown = document.querySelector(`#fileSelect-${fieldId}`);
      fileTypeDropdown.focus();
      return;
    }
    if (selectFileTypeProps && uploadedFileType) {
      fileObj.fileType = uploadedFileType;
      setUploadedFileType('');
      setSelectFileTypeErrorMsg('');
    }
    if (isS3Upload) {
      setIsUploadInProgress(true);
      setSelectedRow((prevState) => [...prevState, rowId]);
      fileObj.fileId = getUniqueFileId(filledFormData[idGenField], fileData.name);
      const formData = new FormData();
      const payload = {
        head: {
          traceId: uuid(),
          span: 'iForm6513',
        },
        body: {
          ...fileObj,
        },
      };
      formData.append('file', fileData);
      formData.append('data', encryptPayload(payload));
      fetch(`${memberApiUrls}/iForms/${formPageType}/s3/upload?cuid=${contextVal.cuid}`, {
        method: 'POST',
        credentials: 'include',
        body: formData,
      })
        .then((response) => response.json())
        .then((data) => {
          if (data && data.statusIndicator === 'T') {
            selectRefs[rowId].current.value = null;
            selectRefs[rowId].current.files = null;
            setS3FileInfo([...s3FileInfo, fileObj]);
            setAllS3FileIds([...allS3FileIds, fileObj.fileId]);
            setTotalFileSz((prev) => prev + fileData.size);
            if (fileInputButton) fileInputButton.innerHTML = `${chooseFileButton}`;
            setFileData('');
            // setIsLoading(false);
          } else {
            // failed to upload file message
          }
          setSelectedRow((prevState) => prevState.filter((it) => it !== rowId));
          setIsUploadInProgress(false);
        });
    } else {
      fileObj.fileId = uuid();
      fileObj.data = fileData;
      setFilesToAttach([...filesToAttach, fileObj]);
      setTotalFileSz((prev) => prev + fileData.size);
      selectRefs[rowId].current.value = null;
      selectRefs[rowId].current.files = null;
      if (fileInputButton) fileInputButton.innerHTML = `${chooseFileButton}`;
      setFileData('');
    }
  };

  useEffect(() => {
    let filesForThisTable = [];
    if (isS3Upload && s3FileInfo.length > 0) {
      filesForThisTable = s3FileInfo.filter((fileObj) => fileObj.fileFrom === fieldId);
    } else if (filesToAttach && filesToAttach.length > 0) {
      filesForThisTable = filesToAttach.filter((fileObj) => fileObj.fileFrom === fieldId);
    }
    setUploadResponse([...filesForThisTable]);
  }, [filesToAttach, s3FileInfo]);

  useEffect(() => {
    if (entityToEdit && entityToEdit[fieldId] && entityToEdit[fieldId].length > 0) {
      if (isS3Upload) {
        entityToEdit[fieldId].forEach((fileObj) => {
          s3FileInfo.push(fileObj);
        });
        setS3FileInfo([...s3FileInfo]);
      } else {
        entityToEdit[fieldId].forEach((fileObj) => {
          filesToAttach.push(fileObj);
        });
        setFilesToAttach([...filesToAttach]);
      }
    }
  }, [entityToEdit]);

  const renderSelectDocumentsBtn = (rowId) => (
    <div className={inputDls}>
      <div
        id={`Documents_1-iforms-input-container-${rowId}`}
        className="Documents_1-iforms-input-container iforms-input-container"
      >
        {fieldValidation && fieldValidation.hideFileInput && (
          <ButtonPrimary
            type="button"
            id={`${rowId}-chooseFileButton`}
            onClick={() => selectRefs[rowId].current.click()}
            className="docs_uploadButton btn-primary btn btn-block margin-1-tb"
          >
            {chooseFileButton}
          </ButtonPrimary>
        )}
        <input
          id={`Documents_1-$${rowId}`}
          className="Documents_1 form-control cursor-wait"
          style={{ padding: '2%', borderColor: '#006fcf', color: '#006fcf' }}
          hidden={hideFileInput}
          type="file"
          // name="Documents_1"
          ref={selectRefs[rowId]}
          onChange={onFileChange}
        />
      </div>
    </div>
  );

  const renderUploadBtn = (rowId, fileId, documentTitle) => (
    <div className={uploadButtonDls}>
      <div id={`docUpload_container-${rowId}`} className="docs_uploadButton-container">
        <ButtonSecondary
          type="button"
          id={`Docupload_button-${rowId}`}
          className="docs_uploadButton btn-secondary btn btn-block margin-1-tb"
          title={uploadButtonLabel}
          loading={isUploadInProgress && selectedRow.filter((item) => item === rowId).length > 0}
          onClick={() => (fileId === 'mapMultipleDocumentsToOne' ? onFileUpload(rowId, documentTitle, true) : onFileUpload(rowId, documentTitle))}
          disabled={!fileData || selectedRow.filter((item) => item === rowId).length === 0}
        >
          {uploadButtonLabel}
        </ButtonSecondary>
      </div>
    </div>
  );

  // total file size and invalid input/size limit validations
  /* eslint-disable max-len -- need */
  const removeUploadDoc = async (fileInfo) => {
    if (uploadResponse && uploadResponse.length > 0) {
      const resp = uploadResponse.filter((response) => response.fileId.includes(fileInfo.fileId))[0];
      if (isS3Upload) {
        fetch(`${memberApiUrls}/iForms/${formPageType}/s3/delete?cuid=${contextVal.cuid}&docKey=${resp.fileId}`, {
          method: 'DELETE',
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json',
          },
        })
          .then((response) => response.json())
          .then((data) => {
            if (data && data.statusIndicator === 'T') {
              const updatedS3Files = s3FileInfo.filter((fileObj) => fileObj.fileId !== resp.fileId);
              setS3FileInfo([...updatedS3Files]);
              // update allS3FileIds
              const currFileIds = [...allS3FileIds];
              const updatedFileIds = currFileIds.filter((fileId) => fileId !== resp.fileId);
              setAllS3FileIds([...updatedFileIds]);
              setTotalFileSz((prev) => prev - resp.size);
              // setIsLoading(false);
            } else {
              // message, failed to delete file
            }
          });
      } else {
        const updatedFilesToAttach = filesToAttach.filter((fileObj) => fileObj.fileId !== resp.fileId);
        setFilesToAttach([...updatedFilesToAttach]);
        setTotalFileSz((prev) => prev - resp.size);
      }
    }
  };

  const getFileData = async (fileId) => {
    try {
      const paramsObj = {
        iformIntegrationUrls,
        cuid: contextVal.cuid,
        pageType: formPageType,
      };

      const requestPayload = {
        head: {
          traceId: uuid(),
          span: 'iForm6513',
          journeyId,
        },
        body: {
          docKey: fileId,
        },
      };

      paramsObj.requestPayload = requestPayload;
      const s3File = await fetchS3Data(paramsObj, 'file');
      const s3FileRes = await s3File.json();
      if (s3FileRes && s3FileRes.file) {
        // get mime type
        const mimeType = getMIMEType(s3FileRes.file);
        const blobFile = base64ToBlobConversion(s3FileRes.file, mimeType);
        const a = window.document.createElement('a');
        a.href = window.URL.createObjectURL(new Blob([blobFile], { type: mimeType }));
        a.download = s3FileRes.fileName;
        // Append anchor to body.
        document.body.appendChild(a);
        a.click();
        // Remove anchor from body
        document.body.removeChild(a);
        setIsView({});
      }
    } catch (e) {
      setIsView({});
    }
  };

  const showUploadedDoc = async (fileInfo) => {
    const loadingArr = [];
    loadingArr[fileInfo.fileId] = true;
    setIsView(loadingArr);
    if (uploadResponse && uploadResponse.length > 0) {
      const resp = uploadResponse.filter((response) => response.fileId.includes(fileInfo.fileId))[0];
      if (isS3Upload) {
        getFileData(resp.fileId);
      }
    }
  };

  /* eslint-enable max-len -- need */

  useEffect(() => {
    validateFile();
    // if we need to manage disable state of buttons
    if (buttonsToDisable.length > 0) {
      let uploadedRequiredDocuments = false;
      documents.every((documentRow) => {
        const requiredDocuments = documentRow.documentRequired;
        let uploadedDocuments = 0;
        documentRow.documents.forEach((item) => {
          const key = item.document_id;
          uploadResponse.every((row) => {
            if (row.rowId.startsWith(key)) {
              uploadedDocuments += 1;
            }
            return true;
          });
        });

        if (uploadedDocuments < requiredDocuments) {
          uploadedRequiredDocuments = false;
          return false;
        } if (uploadedDocuments !== 0) {
          uploadedRequiredDocuments = true;
        }
        return true;
      });

      buttonsToDisable.forEach((btnId) => {
        if (uploadedRequiredDocuments) {
          if (disabledButtons[btnId] && disabledButtons[btnId][fieldId]) {
            delete disabledButtons[btnId][fieldId];
          }
        } else if (disabledButtons[btnId]) {
          disabledButtons[btnId] = { ...disabledButtons[btnId], [fieldId]: 1 };
        } else {
          disabledButtons[btnId] = { [fieldId]: 1 };
        }
      });
      setDisabledButtons({ ...disabledButtons });
    }
  }, [uploadResponse]);

  const checkforSelectionCondition = (option) => {
    if (option.keytoValidate && option.validteFrom === 'filledFormData') {
      if (filledFormData) {
        const value = getVal(filledFormData, option.keytoValidate);
        if (value !== option.valuetoValidateAgainst) {
          return false;
        }
      }
    }
    return true;
  };

  const handleFileTypeChange = (e) => {
    if (e.target.value === '') {
      setSelectFileTypeErrorMsg(selectFileTypeProps.noFileSelectedMsg);
    } else {
      setSelectFileTypeErrorMsg('');
    }
    setUploadedFileType(e.target.value);
  };
  return (
    <>
      {
        selectFileTypeProps && (
          // add a row
          <div className="col-md-12">
            <div className="row">
              <div className={selectFileTypeProps.cssProperties.style}>
                <label
                  className={selectFileTypeProps.fieldLabel.cssProperties.style}
                  htmlFor={`fileSelect-${fieldId}`}
                >
                  {parseHtml(selectFileTypeProps.fieldLabel.label)}
                </label>
                <Select
                  className="select fluid form-control"
                  id={`fileSelect-${fieldId}`}
                  value={uploadedFileType}
                  onChange={handleFileTypeChange}
                >
                  {
                    selectFileTypeProps.fieldOptions.map((option) => (
                      checkforSelectionCondition(option) === true
                        ? (
                          <SelectOption key={option.value} value={option.value}>
                            {option.label}
                          </SelectOption>
                        )
                        : null
                    ))
                  }
                </Select>
                {
                  selectFileTypeErrorMsg
                  && (
                    <div id="alert-error" className="alert dls-color-warning pad-1-t col-md-12">
                      <span className="icon icon-sm dls-icon-warning-filled pad-1-r" />
                      <span>{selectFileTypeErrorMsg}</span>
                    </div>
                  )
                }
              </div>
            </div>
          </div>
        )
      }

      {fieldLabel && fieldLabel.tableInfo1 && <p className="heading-4 col-md-10 dls-deep-blue text-align-center col-md-offset-1 margin-1-t margin-1-b">{parseHtml(fieldLabel.tableInfo1)}</p>}
      {fieldLabel && fieldLabel.tableInfo2 && <p className="label-3 col-md-10 text-align-center col-md-offset-1 margin-1-t margin-1-b">{parseHtml(fieldLabel.tableInfo2)}</p>}
      {fieldLabel && fieldLabel.tableInfo3 && <p className="label-3 col-md-10 text-align-center col-md-offset-1 margin-1-t margin-1-b">{parseHtml(fieldLabel.tableInfo3)}</p>}
      {documents && documents.map((row) => (
        <div className={tableDls} key={`div-${row.document_id}`} style={{ minWidth: '100%' }}>
          <div>
            <Heading
              level={3}
              variant="sans-xlarge-book"
            >
              {parseHtml(row.fieldLabel.label)}
            </Heading>
          </div>
          <DataTableV2
            checkable={null}
            sortable={true}
            id={`dataTable-${fieldId}`}
            key={`dataTable-${fieldId}`}
            className="display-block-sm-down scroll-x-sm-down margin-2-t"
          >
            <DataTableHeadV2>
              {
                tableDynamicProperties
                  && tableDynamicProperties.displayHeaders ? (
                    <DataTableRowV2>
                      {
                      tableDynamicProperties.displayHeaders.map(
                        (item, index) => (
                          <DataTableHeadCellV2
                            className={
                              tableDynamicProperties.displayHeadersCss
                                ? tableDynamicProperties.displayHeadersCss[
                                  index
                                ]
                                : null
                            }
                            key={item}
                          >
                            {item}
                          </DataTableHeadCellV2>
                        ))
                    }
                    </DataTableRowV2>
                  ) : (
                    <DataTableRowV2>
                      <DataTableHeadCellV2 style={{ width: '20%' }}>
                        {tableDocNameHeader}
                      </DataTableHeadCellV2>
                      <DataTableHeadCellV2 style={{ width: '45%' }}>
                        {tableDocNameDescription}
                      </DataTableHeadCellV2>
                      {(row.showUploadOption || typeof row.showUploadOption === 'undefined') && (
                      <DataTableHeadCellV2 style={{ width: '20%' }}>
                        {tableDocStatusHeader}
                      </DataTableHeadCellV2>
                      )}
                      {(row.showUploadOption || typeof row.showUploadOption === 'undefined') && (
                      <DataTableHeadCellV2 align="center" style={{ width: '15%' }}>
                        {tableDocActions}
                      </DataTableHeadCellV2>
                      )}
                    </DataTableRowV2>
                  )
              }
            </DataTableHeadV2>
            <DataTableBodyV2>
              {
                row.documents.length > 0
                && row.documents.map((doc) => (
                  <>
                    {((!formatValid && formatErrorMsg?.doc_id === doc.document_id
                      && formatErrorMsg.message)
                      || (validationMsg?.doc_id === doc.document_id && validationMsg.message
                        && Object.keys(validationMsg).length > 0)
                    )
                      && (
                        <DataTableRowV2 key={`dataTable-${doc.document_id}-errormessage`}>
                          <DataTableCellV2 colSpan="3" style={{ width: '35%' }}>
                            <div className={errorBlockCss}>
                              {!formatValid && <p id="Documents_1_error" className={errorCss}>{parseHtml(formatErrorMsg.message)}</p>}
                              {Object.keys(validationMsg).length > 0 && <p id="validation_error" className={errorCss}>{parseHtml(validationMsg.message)}</p>}
                            </div>
                          </DataTableCellV2>
                        </DataTableRowV2>
                      )}
                    <DataTableRowV2 key={`dataTable-${doc.document_id}`}>
                      <DataTableCellV2 style={{ width: '35%' }}>
                        {doc.title}
                      </DataTableCellV2>
                      <DataTableCellV2 style={{ width: '45%' }} colSpan={typeof row.showUploadOption !== 'undefined' && !row.showUploadOption && tableDynamicProperties.displayHeaders ? tableDynamicProperties.displayHeaders.length - 1 : 1}>
                        <ul>
                          {doc.description.map((it, dindex) => (
                            // eslint-disable-next-line react/no-array-index-key -- desc
                            <li key={`li-${doc.document_id}_${dindex}`}>
                              {it}
                            </li>
                          ))}
                        </ul>
                      </DataTableCellV2>
                      {(row.showUploadOption || typeof row.showUploadOption === 'undefined') && (
                        <DataTableCellV2 style={{ width: '20%' }}>
                          {renderSelectDocumentsBtn(doc.document_id)}
                          {renderUploadBtn(doc.document_id, fieldId, doc.title)}
                        </DataTableCellV2>
                      )}
                    </DataTableRowV2>
                    {
                      s3FileInfo && s3FileInfo.length > 0
                      && s3FileInfo.filter((response) => response.id
                        && response.id.includes(doc.document_id))
                        .map((frow) => (
                          <>
                            {
                              comments && comments[frow.fileId]
                              && (
                                <DataTableRowV2 key={`dataTable-${frow.fileId}-errormessage`}>
                                  <DataTableCellV2 colSpan="3" className="text-align-center" style={{ width: '35%' }}>
                                    <p className="dls-red">{comments[frow.fileId].comment}</p>
                                  </DataTableCellV2>
                                </DataTableRowV2>
                              )
                            }
                            <DataTableRowV2 key={`dataTable-${frow.rowId}`}>
                              <DataTableCellV2 style={{ width: '20%' }}>
                                {
                                  frow.name
                                }
                              </DataTableCellV2>
                              <DataTableCellV2 style={{ width: '45%' }}>
                                <p>Document Uploaded Successfully</p>
                              </DataTableCellV2>
                              <DataTableCellV2 align="center" style={{ width: '15%' }}>
                                <div className="flex flex-justify-around">
                                  {(typeof isView[frow.fileId] === 'undefined' || !isView[frow.fileId]) && (
                                    <IconShow
                                      className="icon-hover"
                                      onClick={() => showUploadedDoc(frow)}
                                    />
                                  )}
                                  {isView[frow.fileId] && <ProgressCircle size="sm" />}
                                  <IconTrash
                                    id={`${frow.rowId}_removeBtn`}
                                    onClick={
                                      (e) => removeUploadDoc(frow, e)
                                    }
                                    className="icon-hover"
                                    size="sm"
                                  >
                                    {removeDocButtonLabel}
                                  </IconTrash>
                                </div>
                              </DataTableCellV2>
                            </DataTableRowV2>
                          </>
                        )
                        )
                    }
                  </>
                )
                )
              }
            </DataTableBodyV2>
          </DataTableV2>

        </div>
      ))}
    </>
  );
};

PayloadFileAttachmentV2.propTypes = {
  cssProperties: PropTypes.objectOf(PropTypes.shape),
  fieldValidation: PropTypes.objectOf(PropTypes.shape),
  fieldLabel: PropTypes.objectOf(PropTypes.shape),
  filesToAttach: PropTypes.objectOf(PropTypes.shape),
  setFilesToAttach: PropTypes.func,
  fieldId: PropTypes.string,
  entityToEdit: PropTypes.objectOf(PropTypes.shape),
  s3FileInfo: PropTypes.objectOf(PropTypes.shape),
  setS3FileInfo: PropTypes.func,
  filledFormData: PropTypes.objectOf(PropTypes.shape),
  isS3Upload: PropTypes.bool,
  idGenField: PropTypes.string,
  formPageType: PropTypes.string,
  allS3FileIds: PropTypes.objectOf(PropTypes.shape),
  setAllS3FileIds: PropTypes.func,
  disabledButtons: PropTypes.objectOf(PropTypes.shape),
  setDisabledButtons: PropTypes.func,
  buttonsToDisable: PropTypes.arrayOf(PropTypes.shape),
  tableDynamicProperties: PropTypes.objectOf(PropTypes.shape),
  selectFileTypeProps: PropTypes.objectOf(PropTypes.shape),
  documents: PropTypes.objectOf(PropTypes.shape),
  journeyId: PropTypes.string,
  comments: PropTypes.objectOf(PropTypes.shape),
};

export default PayloadFileAttachmentV2;
